import { motion } from 'framer-motion';
import { IconButton } from '@atoms/IconButton';
import usePopover from '@hook/usePopover/usePopover';
import { ReactComponent as KoreaIcon } from '@assets/icons/ic-korea.svg';
import { ReactComponent as UsaIcon } from '@assets/icons/ic-usa.svg';
import Popover from '@atoms/Popover/Popover';
import useLocales from '@hook/useLocales/useLocales';
import MenuItem from '@atoms/MenuItem/MenuItem';
import { useCallback } from 'react';

const renderFlag = (country) => {
  if (country === 'en') {
    return <UsaIcon data-testid="UsaIcon" />;
  } else {
    return <KoreaIcon data-testid="KoreaIcon" />;
  }
};

export default function TopNavLanguageButton() {
  const popover = usePopover();
  const { currentLang, allLangs, onChangeLang } = useLocales();

  const handleChangeLang = useCallback(
    (newLang: string) => {
      onChangeLang(newLang);
      popover.onClose();
    },
    [onChangeLang, popover],
  );

  return (
    <>
      <IconButton
        data-testid={'languageBtn'}
        component={motion.button}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.97 }}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          ...(popover.open && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        {renderFlag(currentLang.value)}
      </IconButton>
      <Popover
        data-testid="languagePopover"
        open={popover.open}
        onClose={popover.onClose}
        sx={{ width: 200, p: 0 }}
      >
        {allLangs.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === currentLang.value}
            onClick={() => handleChangeLang(option.value)}
          >
            {renderFlag(option.value)}
            {option.label}
          </MenuItem>
        ))}
      </Popover>
    </>
  );
}
